/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const paymentButtonFactory = require('components/payment/payment_button/js/main');
const {default: membershipAncillaries} = require('components/membership/membership_ancillaries/js/main');
const {default: membershipRecaptureCustomers} = require('components/membership/membership_recapture_customers/js/main');
const psd2PopupManagerFactory = require('components/psd2/psd2_popup_manager/js/main');
const handler3DS = require('od-modules/3ds/index').default;
const trackingUtils = require('od-modules/utils/tracking.utils');
const {isMembershipStatusActivated} = require('od-modules/utils/membership_utils');
const isSidebarSummary = $('.side_summary_payment').data('type') === 'sidebarsummary';

const widgetLoader = createWidgetLoader({
    paymentButton: ['payment-button', paymentButtonFactory],
    membershipAncillaries: ['membership-ancillaries', membershipAncillaries.factory],
    membershipRecaptureCustomers: ['membership-recapture-customers', membershipRecaptureCustomers.factory],
    psd2PopupManager: ['psd2-popup-manager', psd2PopupManagerFactory],
});
const widgetsList = Odigeo.autoloadWidgetsAsync({
    getUsersManager: ['users-manager', 'usersmanager'],
    getBinDetection: ['payment-bin-detection-manager', 'bindetectionmanager'],
    getPaymentManager: ['payment-manager', 'paymentmanager'],
    getInvoiceManager: ['invoice-manager', 'invoice_manager'],
    getPriceManager: ['price-breakdown-payments', 'pricemanager'],
    getCollapsibleSummary: ['collapsible-flight-summary-payment', 'collapsible_flight_summary'],
    getSidebar: isSidebarSummary ? ['sidebar-summary-payment', 'sidebar_summary'] : ['trip-summary-price-payment', 'trip_summary_price'],
});
const REGULAR_TOTAL_PRICE = '.regular_total_price';
const PWG_TOTAL_PRICE = '.pwg_total_price';
const $payment = $('#payment');

module.exports = {
    viewEvents: function() {
        return {
            'global:userLogged': 'onLoggedUser',
            'global:userNotLogged': 'onNotLoggedUser',
            'global:userLogout': 'onNotLoggedUser',
            'repricing-popup-manager:confirmRepricing': 'onConfirmRepricing',
            'repricing-popup-manager:stopPSD2Waiting': 'onStopPSD2Waiting',
            'psd2-popup-manager:openBankPageNewTab': 'psd2OpenBankPageFromSession',
            'payment-manager:getCreditCards': 'onGetCreditCards',
            'payment-manager:addCreditCards': 'onAddCreditCards',
            'payment-manager:deleteCreditCards': 'onDeleteCreditCards',
            'payment-manager:storedCardChanged': 'onCcMethodTypeSelected',
            'expanded-summary:panelCollapsed': 'onExpandedSummaryClosed',
            'collapsed-summary:panelCollapsed': 'onCollapsedSummaryClosed',
            'users-manager:deleteCreditCardsOk': 'onDeleteCreditCardsOK',
            'users-manager:getCreditCardOk': 'onStoredCreditCard',
            'users-manager:addCreditCardsOk': 'onStoredCreditCard',
            'promotional-codes:updatePrices': 'onPromotionalCodesUpdatePrices',
            'deleteStoredCreditCardHide': 'onCloseRemoveCreditCardHint',
            'payment-manager:getExpectedPriceFromDOM': 'onGetExpectedPriceFromDOM',
        };
    },
    eventHandlers: function() {
        return {
            onGetExpectedPriceFromDOM(resolve) {
                let expectedPriceFromDOM = 0;
                return widgetLoader.get('paymentButton').get('isPWGButton').then((isPWGButton) => {
                    if (isPWGButton) {
                        expectedPriceFromDOM = $payment.find(PWG_TOTAL_PRICE).data('total-price');
                    } else {
                        expectedPriceFromDOM = $payment.find(REGULAR_TOTAL_PRICE).data('total-price');
                    }
                    return resolve(parseFloat(expectedPriceFromDOM).toFixed(2));
                });
            },
            onGetCreditCards: function() {
                widgetsList.getUsersManager().execute('submitUserRequest', {action: 'getCreditCard'});
            },
            onAddCreditCards: function(creditCards) {
                widgetsList.getUsersManager().execute('submitUserRequest', {action: 'addCreditCards', data: creditCards});
            },
            onDeleteCreditCards: function(creditCards) {
                widgetsList.getUsersManager().execute('submitUserRequest', {action: 'deleteCreditCards', data: creditCards});
            },
            onDeleteCreditCardsOK: function(data) {
                var paymentManager = widgetsList.getPaymentManager();
                paymentManager.execute('creditCardRemoved');
                paymentManager.execute('setCreditCards', data);
            },
            onStoredCreditCard: function(data) {
                var paymentManager = widgetsList.getPaymentManager();
                paymentManager.execute('setCreditCards', data).then(() => {
                    paymentManager.execute('isStoredCardsAvailability').then((isStoredCardsAvailability) => {
                        if (isStoredCardsAvailability) {
                            widgetsList.getBinDetection().execute('triggerInputEventOnCreditCardInput');
                        }
                    });
                });
            },
            onCollapsedSummaryClosed: function() {
                widgetsList.getCollapsibleSummary().execute('expandSummaryPanel', true);
            },
            onExpandedSummaryClosed: function() {
                widgetsList.getCollapsibleSummary().execute('expandSummaryPanel', false);
            },
            onLoggedUser: function({userDTO}) {
                widgetsList.getPaymentManager().execute('userLogged', userDTO);
                widgetsList.getInvoiceManager().execute('userLogged', userDTO);
                const membershipDTO = Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO', null);
                if (isMembershipStatusActivated(membershipDTO) && !Odigeo._.isEmpty(userDTO.membershipInfoDTO.errorDTOs)) {
                    var errorDTO = Odigeo._.head(userDTO.membershipInfoDTO.errorDTOs);
                    var isPerksUsageExceeded = !Odigeo._.isUndefined(errorDTO.code) && errorDTO.code === 'UNL_VELOCITY_RULES_EXCEDEED';
                    widgetsList.getSidebar().execute('updateIsPrimeBlocked', isPerksUsageExceeded);
                }
            },
            onNotLoggedUser: function() {
                widgetsList.getPaymentManager().execute('userNotLogged');
            },
            onCloseRemoveCreditCardHint: function() {
                widgetsList.getPaymentManager().execute('removeCreditCardHintClosed');
            },
            onConfirmRepricing: function() {
                widgetLoader.get('psd2PopupManager').execute('toggleWaiting', true);
                widgetsList.getPaymentManager().execute('commit', false);
            },
            onStopPSD2Waiting: function() {
                widgetLoader.get('psd2PopupManager').execute('toggleWaiting', false);
            },
            psd2OpenBankPageFromSession() {
                const confirmInteractionNeededData = Odigeo.Utils.parseJson(Odigeo.Session.get('confirmInteractionNeededData'));
                handler3DS.createIframeWithData(confirmInteractionNeededData, false);
            },
        };
    },
    isLoggedIn: function() {
        if (!Odigeo._.isNull(Odigeo.Session.storage.lastRouteChange)) {
            widgetsList.getUsersManager().execute('submitUserRequest', {data: '', action: 'isLoggedIn'});
        }
    },
    delayIframe() {
        if (Odigeo.SessionScope.flow === 'mobile') {
            widgetLoader.get('psd2PopupManager').execute('removeIframeClasses');
            widgetLoader.get('psd2PopupManager').execute('toggleWaiting', true);
        }
    },
    psd2Restore() {
        const method = Odigeo.SessionScope.flow === 'mobile' ? 'toggleIframeFullPage' : 'toggleIframe';
        const confirmInteractionNeededData = Odigeo.Utils.parseJson(Odigeo.Session.get('confirmInteractionNeededData'));

        if (confirmInteractionNeededData) {
            trackingUtils.trackEvent('psd2_popup', 'payment_page_reloaded_with_iframe');
            if (Odigeo.AB.isRecoverIframeOnRefresh) {
                this.delayIframe();
                widgetLoader.get('psd2PopupManager').execute(method, true);
                setTimeout(() => {
                    handler3DS.createIframeWithData(confirmInteractionNeededData);
                    trackingUtils.trackEvent('psd2_popup', 'iframe_restored_on_reload');
                }, 2000);
            }
        }
    },
};

